// import { useGetCicoKycStatusQuery } from "apis";
import { ViewSwitcher } from "components";
import { usePartialState } from "hooks";
import { PageProps } from "interfaces";
// import { useMemo, useRef } from "react";
import { useLocation } from "react-router";
// import { useLocation } from "react-router";
import { CicoKYCSuccess } from "./CicoKYCSuccess";
import { CicoStepThree } from "./CicoStepThree";
import { StepOne } from "./StepOne";
import { StepThree } from "./StepThree";
// import { StepThree } from "./StepThree";
import { StepTwo } from "./StepTwo";
import { SuccessView } from "./Success";
// import { SuccessView } from "./Success";

interface RegistrationFormsProps extends PageProps {}

export interface FormState {
  firstName: string;
  lastName: string;
  country: string;
  nationality: string;
  dateOfBirth: string;
  phone?: string;
  address?: string;
  city?: string;
  zipCode?: string;
  phoneCode?: string;

  documentType: string;
  selfieDocument: string;
  identificationDocument: string;
  documentCategory: "primaryId";

  identitficationFile: File;
}

export function RegistrationForms(props: RegistrationFormsProps) {
  // const lastStatus = useRef("none");
  // const { setCurrentView, maxViews } = useModalView();

  // const { data } = useGetCicoKycStatusQuery({});
  const [state, set, reset] = usePartialState<FormState>({
    // firstName: "Dayo",
    // lastName: "Famuyiwa",
    // dateOfBirth: "2023-10-1",
    // address: "60 shonola street, ogba",
    // nationality: "nigeria",
    // city: "ikeja",
    // phone: "8136778355",
    // zipCode: "100218",

    documentCategory: "primaryId",
  });

  // lastStatus.current = data?.status ?? "none";
  // const status = useMemo(() => data?.status ?? "Unknown", [data]);

  // if (status === "pending" || status === "approved") {
  //   setCurrentView(maxViews - 1);
  // }

  const { pathname } = useLocation();

  console.log(pathname, "THE WHOLE STATE");
  return (
    <ViewSwitcher>
      <StepOne state={state} set={set} />
      <StepTwo state={state} set={set} />

      {pathname === "/kyc" && <StepThree state={state} set={set} />}
      {pathname === "/kyc" && <SuccessView reset={reset} />}

      {pathname === "/cico" && <CicoStepThree state={state} set={set} />}
      {pathname === "/cico" && <CicoKYCSuccess reset={reset} />}
    </ViewSwitcher>
  );
}
